import { Injectable } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthServiceInterface } from './auth-service.interface';
import { UserProfileApiService } from 'src/app/api/services';
import { StorageEnums } from 'src/shared/models/enums';
import { CustomSpinnerService } from 'src/shared/services/helpers/custom-spinner.service';
import { EventsService } from 'src/shared/services/helpers/events.service';

@Injectable({
	providedIn: 'root'
})
export class AuthService implements AuthServiceInterface {
	isAuthorized = false;
	private userAuth: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public $userAuth: Observable<boolean>;

	constructor(private profileUserService: UserProfileApiService,
				private loader: CustomSpinnerService,
				private eventsService: EventsService,
				private storage: StorageService) {
		this.$userAuth = this.userAuth.asObservable();
	}

	/**
	 * check user permissions to do main user actions: close/open box, create/terminate/pay
	 * @param onVerified
	 * @param onUnverified
	 */
	public checkVerification(onVerified, onUnverified) {
		if (this.isAuthorized) {
			this.loader.show().then(() => {
				return this.profileUserService.getUserProfile()
					.subscribe(async (p) => {
						const isVerified = Boolean(p?.roles.find(v => v.name === 'ROLE_USER'));
						await this.storage.setItem(StorageEnums.USER_FIELDS_VERIFIED, isVerified);
						setTimeout(() => {
							this.eventsService.updateProfile(p);
						}, 150);
						this.loader.hide();
						if (isVerified) {
							onVerified();
						} else {
							onUnverified();
						}
					});
			});
		}
	}

	public updateAuth(isAuth: boolean) {
		this.isAuthorized = isAuth;
		this.userAuth.next(isAuth);
	}

	public getAuthObs(): Observable<boolean> {
		return this.$userAuth;
	}
}
